import { PageResponse } from '@models/page';
import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

export function getNextPageParam<T>(lastPage: PageResponse<T>) {
    return lastPage.page.isLast ? undefined
        : lastPage.page.currentPage + 1;
}

export function getFlattenPageResponse<T>(info: UseInfiniteQueryResult<InfiniteData<PageResponse<T>>>) {
    return info.data?.pages
        ?.map((it) => it.content)
        .flat();
}

export function getIsBlank<T>(info: UseInfiniteQueryResult<InfiniteData<PageResponse<T>>>) {
    const data = getFlattenPageResponse(info);
    return info.isFetched && data?.length === 0;
}
